'use strict';

import {organizationModel} from '../../models/organizationmodel.js';
import {userModel} from '../../models/usermodel.js';

export class RegisterCtrl
{
	
	$scope;
	notify;
	jsDataService;
	pageProgress;
	$http;
	$filter;
	$mdDialog;
//	submitUrl;

	progress = false;
	submitted = false;
	searchNow = false;
	completed = false;
	
	recaptchaResponse;
	classif = {};
	organization = {};
	user = {};
	
	constructor($scope, $http, $filter, $mdDialog, jsDataService, notify, pageProgress){
		'ngInject';
		this.organization = new organizationModel({});
		this.user = new userModel({});
		this.$scope = $scope;
		this.$http = $http;
		this.$filter = $filter;
		this.$mdDialog = $mdDialog;
		this.notify = notify;
		this.jsDataService = jsDataService;
		this.pageProgress = pageProgress;
		this.classif = this.jsDataService.get('classif', {});
//		this.submitUrl = this.jsDataService.get('submitUrl', '');
//		this.organizationLegalStatus();
	}
	
	submitRegister(e){
		const url = this.jsDataService.get('submitUrl');
		if(url){
			const confirmTexts = this.jsDataService.get('registerConfirmTexts');
			let confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(e)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			const self = this;
			this.$mdDialog.show(confirm).then(function () {
				const rec = self.jsDataService.get('recaptcha');
				if(rec){
					grecaptcha.ready(function() {
						grecaptcha.execute(rec.siteKey, {action: 'submit'}).then(function(token){
							self.recaptchaResponse = token;
							self.submitData(e);
						});
					});
				}
				else{
					self.submitData(e);
				}
			}, function () {});
		}
	}
	
	submitData(e){
		const url = this.jsDataService.get('submitUrl');
		if(url){
			const self = this;
			let dat = this.collectPostData();
//			const rec = this.jsDataService.get('recaptcha');
//			if(rec){
//				dat[rec.field] = this.recaptchaResponse;
//			}
			this.$scope.basicHttpConfigProcess({
				url: url,
				method: 'POST',
				responseType: 'json',
				data: dat
			}).then(function(response){
				self.progress = false;
				if(response.data){
					if(response.data.success){
						self.submitted = false;
						self.completed = true;
					}
					else{
						self.submitted = false;
					}
				}
			}, function(response){
				self.progress = false;
				self.submitted = false;
			});
		}
	}
	
	collectPostData(){
		let data = {};
		const rec = this.jsDataService.get('recaptcha');
		if(rec){
			data[rec.field] = this.recaptchaResponse;
		}
		data.organization = this.organization;
		data.user = this.user;
		
		return data;
	}
	
	legalStatusChange(){
		if(this.organization.reglegal_status_id === 'oth'){
			this.organization.legal_status_other = true;
		}
		else{
			this.organization.legal_status_other = false;
		}

		if(this.organization.legal_status_other){
			this.organization.legalStatusOther(true);
		}
		else{
			this.organization.legalStatusOther(false);
		}
//		if(this.organization.reglegal_status && this.organization.reglegal_status.length > 0){
//			let oth = this.$filter('filter')(this.organization.reglegal_status, {id: 'oth'});
//			if(oth.length > 0){
//				this.organization.legalStatusOther(true);
//			}
//			else{
//				this.organization.legalStatusOther(false);
//			}
//		}
//		else{
//			this.organization.legalStatusOther(false);
//		}
	}
	
	isNumber(){
		return (typeof(this.organization) !== 'undefined' && this.organization.registration_number && this.organization.registration_number !== '');
	}
	
	autoFill(e){
		const url = this.jsDataService.get('companyFindUrl', '');
		if(this.isNumber() && url !== ''){
			this.searchNow = true;
			const self = this;
			let rqq = this.$http({
				url: url,
				method: 'GET',
				responseType: 'json',
				params: {
					registration_number: this.organization.registration_number
				}
			});
			this.$scope.onlyHttpProcess(rqq).then((response) => {
				this.searchNow = false;
				if(response.data && response.data.success){
					delete response.data.data.id;
					this.organization = new organizationModel(response.data.data);
					this.legalStatusChange();
				}
			}, () => this.searchNow = false);
		}
	}
	
//	organizationLegalStatus(){
//		if(typeof(this.organization.legal_status) === 'undefined'){
//			this.organization.legal_status = [];
//		}
//		if(this.organization.legal_status_ids.length > 0){
//			for(let lsid of this.organization.legal_status_ids){
//				let r = this.$filter('filter')(this.classif.legal_status, {id: lsid}, true);
//				if(r.length > 0){
//					this.organization.legal_status.push(r[0]);
//				}
//			}
//		}
//	}
}


